import { useContext, useState } from 'react';

import { isFilterableDataType } from '@atom/components/common/workOrdersFilters/fieldFilterUtilities';
import WorkOrderFieldFilterInput from '@atom/components/common/workOrdersFilters/WorkOrderFieldFilterInput';
import WorkOrdersContext, {
  getTaskCommonField,
  WorkOrdersInputActionTypes,
} from '@atom/components/workOrders/WorkOrdersContext';
import { Icon, IconButton } from '@atom/mui';
import { KeyboardArrowDownIcon, KeyboardArrowUpIcon } from '@atom/mui/icons';
import { FieldFilter } from '@atom/types/work';
import { isNilOrEmpty } from '@atom/utilities/validationUtilities';

import classes from './workOrdersFilters.module.css';

const WorkOrdersTaskCustomFieldsFilter = () => {
  const { customFieldFilters, workOrdersInputCart, filtersDisabled, dispatch } =
    useContext(WorkOrdersContext);

  const [collapsed, setCollapsed] = useState<boolean>(false);

  const onFieldFilterChange = (fieldFilter: FieldFilter) =>
    dispatch({
      type: WorkOrdersInputActionTypes.UPDATE_TASKS_COMMON_FIELD,
      data: { fieldFilter },
    });

  return !isNilOrEmpty(customFieldFilters) ? (
    <div>
      <div className={classes.filtersSectionHeader}>
        <div>Common Fields</div>
        <IconButton
          onClick={() => setCollapsed(!collapsed)}
          edge="end"
          data-cy="workOrdersFilterCommonFieldsCollapseButton"
        >
          <Icon
            icon={collapsed ? KeyboardArrowDownIcon : KeyboardArrowUpIcon}
          />
        </IconButton>
      </div>
      {!collapsed &&
        customFieldFilters
          .filter(field => isFilterableDataType(field.dataType))
          .map(field => (
            <div className={classes.customFieldContainer} key={field.id}>
              <WorkOrderFieldFilterInput
                field={field}
                fieldFilter={getTaskCommonField(workOrdersInputCart, field.id)}
                onChange={onFieldFilterChange}
                disabled={filtersDisabled}
                dataCy={`workOrdersFilterCommonField-${field.title}`}
              />
            </div>
          ))}
    </div>
  ) : (
    <div />
  );
};

export default WorkOrdersTaskCustomFieldsFilter;
